import React from 'react';
import styles from './RoleplayView.module.scss';
import RoleplayViewDescriptionHeader from './RoleplayViewDescriptionHeader';
import RoleplayViewDescriptionBody from './RoleplayViewDescriptionBody';
import RoleplayViewDescriptionFooter from './RoleplayViewDescriptionFooter';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import ViewDescriptionRetakeOption from './ViewDescriptionRetakeOption';
const RoleplayViewDescription = () => {
  const { showRetake, attempt } = useRoleplayStore();
  return (
    <div className={styles.background}>
      <RoleplayViewDescriptionHeader />
      {showRetake && attempt === 1 ? (
        <ViewDescriptionRetakeOption />
      ) : (
        <>
          <RoleplayViewDescriptionBody />
          <RoleplayViewDescriptionFooter />
        </>
      )}
    </div>
  );
};

export default RoleplayViewDescription;
